import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import cate from './modules/cate'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules:{
      user,cate
    },
    getters
})

export default store